import { render, staticRenderFns } from "./BudgetSettingItem.vue?vue&type=template&id=5ccda826&scoped=true&"
import script from "./BudgetSettingItem.vue?vue&type=script&lang=js&"
export * from "./BudgetSettingItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ccda826",
  null
  
)

export default component.exports